<template>
    <modal v-if="dialog">
      <div class="reward card card--default">
        <confetti />
        <h1 style="text-align: center">Congratulations!</h1>
        <h3 style="text-align: center">Choose a present as a reward</h3>
        <div class="row space-around small-top align-items" style="height: 80px">
          <chose @selected="createBonus" :show="!!selected" v-for="i in 3" :key="i" />
        </div>
        <div class="card total-pts" v-if="!!selected && raffle.bonuses.length > 0">
          <div class="row">
            <div style="flex: 1" class="pts">
              <div>Total Points</div>
              <div style="text-align: center">
                <div style="font-size: 50px">+{{raffle.num_of_points}}</div>
              </div>
            </div>
            <div style="flex: 3; justify-content: center; display: flex; flex-direction: column;">
              <h3 v-for="(bonus, i) in raffle.bonuses" :key="i" :class="{'small-top': i > 0}">
                +{{bonus[2]}} pts. (+{{bonus[0]}}% {{bonus[1]}})
              </h3>
              <div v-if="raffle.bonuses.length == 0 && loading !== true">
                <h3>Hmmm... doesn't look like you qualified for any bonuses.</h3>
                <h3 class="small-top">You earn bonuses when you are consistently doing your habits and reflections. The more consistent you are, the more bonuses you earn.</h3>
              </div>
            </div>
          </div>
        </div>

        <div class="row small-top space-around">
          <div style="margin-top: 20px">
            <h3>You've Earned </h3>
            <div class="small-top points-circle">
              <div>{{total}} <span style="font-size: 20px">pts</span></div>
            </div>
          </div>

          <div class="small-top">
            <div class="">
              <button class="btn btn--outline small-top margin-right btn--full" @click="learnMore">Learn More</button>
              <button class="btn btn--outline small-top btn--full" @click="finish">Finish</button>
            </div>
            <!-- <div class="row align-center col-at-xs small-top">
              <h2>Tell the world</h2>
              <social-links :link="campaignLink"></social-links>
            </div> -->
          </div>
        </div>
      </div>
    </modal>
    <div v-else-if="displayTaskRewards" >
      <confetti />
      <task-rewards @close="displayTaskRewards = false" />
    </div>
</template>

<script>
import dataStore from "@/services/api/store";
import raffleHub from "@/services/hubs/raffle";
import modal from "@/components/modal";
import socialLinks from "@/components/socialLinks";
import User from "@/services/api/authUser";
import confetti from "@/components/confetti";
import chose from "./chose";
import axios from "axios";
import taskRewards from "./taskRewards";

const CLIENT_RAFFLE = "ClientRaffle";

export default {
  data() {
    return {
      dialog: false,
      complete: false,
      user: User,
      campaign: {},
      selected: 0,
      loading: false,
      totalPts: 0,
      displayTaskRewards: false,
      raffle: {
        bonuses: []
      }
    };
  },
  components: {
    modal,
    socialLinks,
    confetti,
    chose,
    taskRewards
  },
  computed: {
    campaignLink() {
      return `/create-the-change/${this.campaign.id}/${this.campaign.slug}`;
    },
    total() {
      return this.totalPts.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  created() {
    axios.get(`${process.env.VUE_APP_API_URL}clients/raffles/total_points/`)
      .then(({ data }) => {
        this.totalPts = data.total || 0;
      });

    raffleHub.clearListeners();
    this.reInit();
    raffleHub.registerListener(entryType => {
      this.reInit();
      this.entryType = entryType;
      const promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // this.dialog = true;
      User.getUser(User.id).then(user => {
        this.user = user;
        if (!user.raffle_opt_in) {
          if (user.reward !== "none") {
            this.displayTaskRewards = true;
          } else {
            this.resolve();
            this.dialog = false;
            this.reject();
          }
          return;
        } else {
          axios.get(`${process.env.VUE_APP_API_URL}clients/raffles/eligible_for_reward/?reward=${entryType}`)
            .then(({data}) => {
              if (data.is_eligible) {
                this.dialog = true;
              } else if (user.reward !== "none") {
                this.displayTaskRewards = true;
              }
            });
        }
      });
      return promise;
    });
  },
  methods: {
    finish() {
      if (this.user.reward !== "none") {
        this.displayTaskRewards = true;
      }
      this.dialog = false;
    },
    reInit() {
      this.dialog = false;
      this.raffle = { bonuses: [] };
      this.loading = false;
      this.selected = 0;
      this.entryType = "";
    },
    learnMore() {
      this.$router.push('/create-the-change/3/send-a-girl-to-school');
      this.dialog = false;
    },
    createBonus(number) {
      this.selected = number;
      this.loading = true;
      dataStore
        .create(CLIENT_RAFFLE, {
          entry_type: this.entryType || "exercise",
          campaign: "3",
          rolled_points: number
        })
        .then(raffle => {
          this.raffle = raffle;
          this.loading = false;
          this.totalPts += raffle.num_of_points;
        });
    },
    close() {
      this.resolve();
      this.reInit();
      // this.$emit("updateTickets", this.num_of_tickets);
      clearInterval(this.timer);
      this.clickedStop = false;
    }
  },
};
</script>

<style lang="less" scoped>
.reward {
  // min-height: 500px;
  width: 500px;
  max-width: 100%;
}
.align-items {
  align-items: center;
}

.gifts {
  font-size: 135px;
}
.points-circle {
  min-width: 100px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: white;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #70BFF6;
}
.total-pts {
  background-color: white;
  color: #70BFF6 !important;
  font-weight: 500;
}

.pts {
  border-right-width: 1px;
  border-right-color: #70BFF6;
  border-right-style: solid;
  padding-right: 20px;
  margin-right: 20px;
}

.display-winning {
  animation: fade-in 1.5s;
  animation-fill-mode: forwards;
  font-size: 20px;
}

canvas {
  overflow-y: hidden;
  overflow-x: hidden;
  width: 100%;
  margin: 0;
}

.bonus-total {
  border-top: solid;
  border-top-width: 1px;
  padding-top: 10px;
  margin-top: 10px;
}
</style>
